module.exports = __webpack_public_path__ + "static/media/Kan-Kaw-Myaing.048531b3.png";